module.exports = __webpack_public_path__ + "static/media/downloadplaystore.f06b9089.png";